import classNames from 'classnames';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { ButtonTWClasses, ColorlessButtonClasses } from '../buttonTW/ButtonTW';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';

export interface ILinkTWProps extends LinkProps, IHasTestData {
  isButton?: boolean;
  secondary?: boolean;
  ghost?: boolean;
}

export const LinkTW: React.FC<ILinkTWProps> = ({ isButton, secondary, ghost, className, ...rest }) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const useSpruceColors = !isZillowClosingEnabled;
  
  const classes = isButton ? [
    ButtonTWClasses({ secondary, ghost, useSpruceColors }), 
    ColorlessButtonClasses
  ] : [];
  
  return <Link className={classNames(classes, className)} {...rest} />;
};
